module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-content"
  }, _vm._l((_vm.configArr), function(item) {
    return _c('div', {
      staticClass: "map-item"
    }, [_c('div', {
      staticClass: "key",
      domProps: {
        "innerHTML": _vm._s(item.cn)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "value",
      domProps: {
        "innerHTML": _vm._s((Array.isArray(_vm.detailObj[item.en]) ? _vm.detailObj[item.en].join(',') : _vm.detailObj[item.en]) || '--')
      }
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca92a95a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail-map.vue
// module id = 179
// module chunks = 1